import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Brand } from 'projects/Administration/src/app/business-entities/brand.model';
import { EditSpecialTool, SpecialToolModel, SpecialToolType } from 'projects/Administration/src/app/business-entities/special-tool-model';
import { RentalCarService } from 'projects/Administration/src/app/business-services/rental-car.service';
import { SpecialToolBusinessService } from 'projects/Administration/src/app/business-services/special-tool.service';
import { ImageService } from 'projects/Administration/src/app/services/image.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { BaseService } from 'projects/Autofacets-Core/src/app/services/base.service';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import * as Enums from './../../../../../../../Autofacets-Core/src/app/utils/enums';
import { VehicleType } from '../../../../business-entities/vehicle-list-view-model';
import { CheckListBusinessService } from '../../../../business-services/check-list.service';
import { Constant } from '../../../../../../../Autofacets-Core/src/app/utils/constant'
@Component({
  selector: 'app-edit-special-tool',
  templateUrl: './edit-special-tool.component.html',
  styleUrls: ['./edit-special-tool.component.css']
})
export class EditSpecialToolComponent implements OnInit {
  editSpecialTool = false;
  editSpecialToolForm: FormGroup;
  brandList: Brand[] = [];
  brand: Brand[];
  id: number;
  language: string;
  image: string | ArrayBuffer;
  //specialTool: SpecialTool;
  SpecialToolModel:SpecialToolModel;
  editedSpecialTool: EditSpecialTool = {
    brandId: null,
    partNumber: "",
    partDescription: "",
    partGroup: "",
    partImage: "",
    updatedBy: "",
     pc: null,
     lcv: null,
     truck: null,
    imageBinaryData: "",
    mimeType: "",
    image: "",
    specialToolImage: ""
  };
  imageBaseData: string | ArrayBuffer = null;
  allLanguage: any[];
  vehicleTypes: VehicleType[] = [];
  specialToolTypes: SpecialToolType[] = [];
  constructor(
    private formBuilder: FormBuilder,
    private getAllBrandData: RentalCarService,
    private specialToolService: SpecialToolBusinessService,
    private spinner: NgxSpinnerService,
    private baseService: BaseService,
    private toastr: ToastrService,
    private router: Router,
    private translate: TranslateService,
    private currentLanguageService: CurrentLanguage,
    private cdr: ChangeDetectorRef,
    private activeModal : NgbActiveModal,
    private userService: UserDataService,
    private imageService:ImageService,
    private checkListService: CheckListBusinessService
  ) { }

  ngOnInit(): void {
    this.allLanguage = this.currentLanguageService.LanguageList;
    this.editSpecialToolForm = this.formBuilder.group({
      partDescription: new FormArray([]),
      brand: [null, [Validators.required]],
      partNumber: [''],
      partGroup: [''],
      isActive: [''],
      vehicletype:[null],
      specialToolTypeId:[''],
    });
    this.getBrandData();
    this.getLanguage();
    this.GetAllVehicleTypes();
    this.editSpecialToolForm.controls.brand.disable();
    this.GetAllSpecialToolTypes();
  }

  getLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.t.length < number) {
        for (let i = this.t.length; i < number; i++) {
            this.t.push(this.formBuilder.group({
                languageId: [''],
                description: ['', Validators.required],
            }));
        }
    } else {
        for (let i = this.t.length; i >= number; i--) {
            this.t.removeAt(i);
        }
    }
}
async GetAllVehicleTypes(): Promise<void> {
  await this.checkListService.getVehicleTypes().then(data => {
    if(localStorage.getItem("Theme") == Constant.BnhInterface){
      this.vehicleTypes = data.responseObject;
    }
    else{
      this.vehicleTypes = data.responseObject.filter(x => x.isDisplay);
    }
  });
}
  async getBrandData() {
    this.id = this.specialToolService.SpecialToolId
    await this.GetAllBrand();
    this.currentLanguageService.currentLanguage.subscribe(x => {
      this.language = x
      this.getSpecialTool(this.id);
    });
  }
  async GetAllSpecialToolTypes(): Promise<void> {
    await this.specialToolService.getAllSpecialToolTypes().then(data => {
      this.specialToolTypes = data.responseObject
    });
  }
  get cpf() {
    return this.editSpecialToolForm.controls;
  }

  get t() { return this.cpf.partDescription as FormArray; }

  async GetAllBrand() {
    await this.getAllBrandData.GetAllBrand().then(data => {
      this.brand = data.responseObject;
      for (let value of this.brand) {
        this.brandList.push(value)
      }
    })
  }
  onChangeFileUpload(files: FileList) {
    const me = this;
    const file = files[0];
    this.editedSpecialTool.mimeType = files[0].type;
    this.editedSpecialTool.image = files[0].name;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (_readerEvent) => {
      this.SpecialToolModel.specialToolDetails.partImage = "";
      me.imageBaseData = reader.result;
      this.editedSpecialTool.imageBinaryData = reader.result.toString().replace('data:' + this.editedSpecialTool.mimeType + ';base64,', '');
      this.editedSpecialTool.specialToolImage = me.imageBaseData;
      this.image = me.imageBaseData;
    };
    reader.onerror = function (_error) {
      // This is intentional
    };

  }
  async getSpecialTool(id: number) {
    this.spinner.show();
    await this.specialToolService.getSpecialToolById(id).then(result => {
      if (result) {
        this.SpecialToolModel=result.responseObject;
        this.image = this.SpecialToolModel.specialToolDetails.partImage === null ? './../../../assets/images/no-img.png' :  this.SpecialToolModel.specialToolDetails.partImage
        this.editSpecialToolForm.controls["brand"].setValue(this.SpecialToolModel.specialToolDetails.brand);
        this.editSpecialToolForm.controls["specialToolTypeId"].setValue(Number(this.SpecialToolModel.specialToolDetails.type));
        this.editSpecialToolForm.patchValue({
          ...result.responseObject,
          vehicletype: this.SpecialToolModel.specialToolDetails.vehicleType,
        })
      }
    })
    this.spinner.hide();
  }
  editSpecialTools() {
    this.spinner.show();
    let currentUser = this.userService.currentUserValue.id;
    const viewModel = {
      ...this.editSpecialToolForm.value,
      image: this.editedSpecialTool.image,
      mimeType: this.editedSpecialTool.mimeType,
      imageBinaryData: this.editedSpecialTool.imageBinaryData,
      updatedBy: currentUser,
      brandId: this.brandList.find(x => x.brandName === this.editSpecialToolForm.get('brand').value).id,
      id: this.SpecialToolModel.specialToolDetails.id
    }
    const isValidFormat=this.imageService.validateImageFormat(this.editedSpecialTool.mimeType);
    if(isValidFormat)
    {
      this.specialToolService.addEditSpecialTool(viewModel).then(res => {
        if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
          let successmsg = this.translate.instant("lblSpecialToolUpdated");
          this.toastr.success(successmsg);
          this.spinner.hide();
          this.activeModal.close({ success: true });
        }
        else if (res.responseObject === false) {
          this.spinner.hide();
          let errormsg = this.translate.instant("lblSpecialToolExist");
          this.toastr.warning(errormsg);
        }
      });
    }
    else {
      let imageErr = this.translate.instant("lblImageFormatError");
      this.toastr.error(imageErr)
    }
    this.spinner.hide();
  }

  ngAfterViewChecked(){
    this.cdr.detectChanges();
 }
 OnClose(){
  this.activeModal.dismiss('Cross click')
}

}
